// HEADLINE ANIMATION
const splitConfig = {
  lines: { duration: 0.9, stagger: 0.1 },
  words: { duration: 0.6, stagger: 0.06 },
  chars: { duration: 0.4, stagger: 0.01 }
}

function initScrollHeadline() {
  document.querySelectorAll('[data-split="heading"]').forEach(heading => {
    gsap.set(heading,{ autoAlpha:1 })

    // Find the split type, the default is 'lines'
    const type = heading.dataset.splitReveal || 'lines'
    const typesToSplit =
      type === 'lines' ? ['lines'] :
      type === 'words' ? ['lines','words'] :
      ['lines','words','chars']
    
    // Split the text
    SplitText.create(heading, {
      type: typesToSplit.join(', '), // split into required elements
      mask: 'lines', // wrap each line in an overflow:hidden div
      autoSplit: true,
      linesClass: 'line',
      wordsClass: 'word',
      charsClass: 'letter',
      onSplit: function(instance) {
        const targets = instance[type] // Register animation targets
        const config = splitConfig[type] // Find matching duration and stagger from our splitConfig
        
        // Check if element is already in view on page load
        const rect = heading.getBoundingClientRect()
        const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0
        
        const animation = gsap.from(targets, {
          yPercent: 125,
          duration: config.duration,
          stagger: config.stagger,
          ease: "cubic-bezier(.165, .84, .44, 1)",
          scrollTrigger: isInView ? undefined : {
            trigger: heading,
            start: 'top 95%',
            once: true
          }
        })
        
        // If already in view, play immediately
        if (isInView) {
          animation.play()
        }
        
        return animation
      }
    })
  })
}
document.fonts.ready.then(function () {
  initScrollHeadline();
});